module.exports = __webpack_public_path__ + "static/desktop/img/material-album.fe39668b.png";